import React, { useState, useEffect, Fragment } from 'react';
import useMedia from "../js/useMedia"
import {useWindowScroll} from 'react-use'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';

import local from "./usr_mnu_localisation.js"

//import Loader from "./Loader"
import './shapka.css'

import {
    Link,
    NavLink
} from "react-router-dom";

export default function UserMenu(){
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const setup = useSelector(state => state.site.setup);
    const uname = useSelector(state => state.site.user);

// Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

// Получаем данные пользователя из localStorage
let user = null;
if(localStorage.user){
    user = JSON.parse(localStorage.getItem("user"));
} else {
    navigate(`/${LANG}/login`, { replace: true });
    return null;
}

// Инициализируем topnav с именем пользователя
const [topnav, setTopnav] = useState([{id: 'user', ttl: uname || user.fio}, {id: 'logout', ttl: local[LANG].logout }]);

    let [isMenu, setMenu] = useState(false)
    let [logoClass, setLogoClass] = useState('logo z10');

    let small = useMedia("(max-width:420px)");
    let large = useMedia("(min-width:650px)");
    const {x, y} = useWindowScroll();
    const location = useLocation();

    var path ='';
    let ltmp = location.pathname.replace(/\/+$/, '').split('/').slice(2).join('/');
    

    useEffect(() => {
        if( y>5 ) {setLogoClass('logo z6')} else {setLogoClass('logo z10')}
    }, [y] );

    // Синхронизация имени пользователя из Redux store с topnav
    useEffect(() => {
        if(uname){
            setTopnav([{id: 'user', ttl: uname}, {id: 'logout', ttl: local[LANG].logout}]);
        }
    }, [uname] );

const toggleMenu =() => isMenu ? setMenu(false) : setMenu(true);

const punkts = (cls) => {
  return <Fragment>
            
            <ul className={cls} onClick={small? toggleMenu : null}>
            {
              topnav.map((i, key) => 
                <Fragment>
                    <li key={key} className={ key===0 ? 'flcntr' : null }>
                    {
                      key===0? <img src={setup.domen + setup.folder + '/svg/userpic.svg'} height='20'/> : null
                    }
                    <Link to={path = i.id === 'home' ? '/'+LANG : '/'+LANG+'/'+i.id}
                        className={(key===0 && !ltmp) || (key!==0 && i.id === ltmp) ? 'active':''}
                    >
                        {i.ttl}
                    </Link>
                    </li>
                </Fragment>
                )
            }
            </ul>
        </Fragment>
      }    
      
return(
    <Fragment>
        {
            large ? <Fragment>
            <div className="NavPenel sticky">
                {
                  punkts('App-header')
                }
                {
                    //<LangSet active={setup.lang}/>
                }
            </div> 
            
            </Fragment>
            : 
            <div key="nav">
                <img src={setup.domen + setup.folder + '/svg/menu.svg'} className="m-top-menu" onClick={toggleMenu} alt="menu"/>
                        {
                        isMenu ? 
                            punkts('Mob-header')
                        :null
                        }
            </div>
        }
        {small? isMenu ? <div key="overlay" className="overlay" onClick={toggleMenu}/>:null:null}
    </Fragment>
)

}